import { FlagIconSource } from '../../utils/imagesource';
import './DownloadDataSection.css';

const countryDataLinks = [
  { label: 'Australia', code: 'AUS', flag: FlagIconSource['AUS'] },
  { label: 'Egypt', code: 'EGY', flag: FlagIconSource['EGY'] },
  { label: 'India', code: 'IND', flag: FlagIconSource['IND'] },
  { label: 'Kenya', code: 'KEN', flag: FlagIconSource['KEN'] },
  { label: 'Laos', code: 'LAO', flag: FlagIconSource['LAO'] },
  { label: 'Nepal', code: 'NPL', flag: FlagIconSource['NPL'] },
  { label: 'Thailand', code: 'THA', flag: FlagIconSource['THA'] },
  { label: 'Uzbekistan', code: 'UZB', flag: FlagIconSource['UZB'] },

  { label: 'Vietnam', code: 'VNM', flag: FlagIconSource['VNM'] },
];

export default function DownloadDataSection() {
  return (
    <div className='help'>
      <h1>Download AviStep Data for Each Country</h1>

        <p >
          By clicking to download the data, you agree to the Terms of Use found
          here:{' '}
          <a href='https://avistep.birdlife.org/terms' style={{ color: 'white' }} >
            https://avistep.birdlife.org/terms
          </a>{' '}
        </p>
        <p>
          Please cite using the following format: BirdLife International, 2025.
          AVISTEP: the Avian Sensitivity Tool for Energy Planning. [country].
          Cambridge, UK: BirdLife International. Accessed at
          avistep.birdlife.org [date].
        </p>

      <section className='download-section'>
        <table className='download-table'>
          <thead>
            <tr>
              <th className='download-th'>Country</th>
              <th className='download-th'>Download</th>
            </tr>
          </thead>
          <tbody>
            {countryDataLinks
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((country) => (
                <tr key={country.code}>
                  <td
                    className='download-td'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>{country.label}</span>
                    <img
                      src={country.flag}
                      alt={country.label + ' flag'}
                      className='download-flag'
                    />
                  </td>
                  <td className='download-td'>
                    <a
                      href={`https://avistepstorage.blob.core.windows.net/avistepfiledatadownload/${country.label}.zip`}
                      className='download-link'
                      download
                    >
                      DATA
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
